module.exports = __webpack_public_path__ + "media/A01.84fc1924.mp4";